import { MissionsEnum } from "@/utils/constants/corpus";
import { Autocomplete, TextField } from "@mui/material";

interface IMissionSelector {
  value: string | null;
  label: string;
  // eslint-disable-next-line no-unused-vars
  handleChange: (value: string) => void;
  options: MissionsEnum[];
}

const MissionSelector: React.FC<IMissionSelector> = ({ value, label, handleChange, options }) => {
  return (
    <Autocomplete
      fullWidth
      disableClearable
      value={value ?? undefined}
      onChange={(_, value: unknown) => {
        if (typeof value === "string") handleChange(value);
        else handleChange("");
      }}
      options={options}
      renderInput={(params) => (
        <TextField {...params} fullWidth sx={{ borderRadius: 3 }} label={label} variant="outlined" />
      )}
    />
  );
};

export default MissionSelector;
